import { connect } from 'react-redux'
import NewAssignmentPreview from '../../../components/employer/assignments/newAssignmentPreview.component'
import { closePreviewNewAssignment } from '../../../actions/employer'

const mapStateToProps = (state) => {
  return {
    state,
    assignmentFormValues: state.assignments.assignmentFormValues
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    closePreviewNewAssignment: () => dispatch(closePreviewNewAssignment())
  }
}

const NewAssignmentPreviewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewAssignmentPreview)

export default NewAssignmentPreviewContainer
